import React from 'react';
import { Link, type LinkProps } from 'react-router-dom';
import { classNames, layoutClassNames, type LayoutClassNameProps } from '../atoms';

export type BoxLinkDisplay = 'block' | 'inline-block';
export type BoxLinkTextDecoration = 'none';

export interface BoxLinkProps extends LinkProps, LayoutClassNameProps {
  display?: BoxLinkDisplay;
  fullHeight?: boolean;
  fullWidth?: boolean;
  textDecoration?: BoxLinkTextDecoration;
  textReset?: boolean;
}

const BoxLink = React.forwardRef<HTMLAnchorElement, BoxLinkProps>(({
  className,
  children,
  display,
  fullHeight = false,
  fullWidth = false,
  margin,
  marginTop,
  marginEnd,
  marginBottom,
  marginStart,
  marginX,
  marginY,
  padding,
  paddingTop,
  paddingEnd,
  paddingBottom,
  paddingStart,
  paddingX,
  paddingY,
  textAlign,
  textDecoration,
  textReset = false,
  ...props
}, ref) => (
  <Link
    ref={ref}
    className={classNames(
      display ? `d-${display}` : undefined,
      fullHeight ? 'h-100' : undefined,
      fullWidth ? 'w-100' : undefined,
      textDecoration === 'none' ? 'text-decoration-none' : undefined,
      textReset ? 'text-reset' : undefined,
      layoutClassNames({
        margin,
        marginTop,
        marginEnd,
        marginBottom,
        marginStart,
        marginX,
        marginY,
        padding,
        paddingTop,
        paddingEnd,
        paddingBottom,
        paddingStart,
        paddingX,
        paddingY,
        textAlign,
      }),
      className,
    )}
    {...props}
  >
    {children}
  </Link>
));

BoxLink.displayName = 'BoxLink';

export default BoxLink;
